
import { motion } from "framer-motion";

interface AboutVisionProps {}

const AboutVision = ({}: AboutVisionProps) => {
  return (
    <section className="px-4 py-16">
      <div className="max-w-4xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center space-y-8"
        >
          <div className="bg-white p-8 rounded-xl shadow-lg border border-corporate-primary-25">
            <h2 className="text-2xl font-bold mb-6 text-corporate-primary-100 flex items-center justify-center">
              <span className="inline-block w-8 h-1 bg-corporate-secondary-100 mr-4"></span>
              Opening Doors to Everyone
              <span className="inline-block w-8 h-1 bg-corporate-secondary-100 ml-4"></span>
            </h2>
            <p className="text-corporate-neutral-75 mb-8 leading-relaxed">
              Crypto can be complex and intimidating. Our goal is to break down those barriers by offering 
              an ecosystem where both newcomers and seasoned traders can access professional strategies. 
              Through third-party verified service providers, METRADE delivers hands-free crypto trading 
              that harnesses real traders' knowledge and expertise.
            </p>
            
            <div className="h-px w-full bg-gradient-to-r from-transparent via-corporate-primary-25 to-transparent my-6"></div>
            
            <h2 className="text-2xl font-bold mb-6 text-corporate-primary-100 flex items-center justify-center">
              <span className="inline-block w-8 h-1 bg-corporate-secondary-100 mr-4"></span>
              Bridging Platforms & Marketplaces
              <span className="inline-block w-8 h-1 bg-corporate-secondary-100 ml-4"></span>
            </h2>
            <p className="text-corporate-neutral-75 mb-8 leading-relaxed">
              METRADE will be the first platform to seamlessly connect crypto exchanges with the MetaTrader (MT5) platform, 
              providing traders with access to centralized and decentralized crypto exchanges. At the same time, 
              METRADE will become the leading marketplace, providing retail users with direct and easy access to 
              the best professional trading strategies, making crypto trading easier and more efficient for everyone.
            </p>
            
            <div className="h-px w-full bg-gradient-to-r from-transparent via-corporate-primary-25 to-transparent my-6"></div>
            
            <h2 className="text-2xl font-bold mb-4 text-corporate-primary-100 flex items-center justify-center">
              <span className="inline-block w-8 h-1 bg-corporate-secondary-100 mr-4"></span>
              Automated, Yet Human-Centric
              <span className="inline-block w-8 h-1 bg-corporate-secondary-100 ml-4"></span>
            </h2>
            <p className="text-corporate-neutral-75 leading-relaxed">
              While our platform is powered by advanced automation, we remain grounded in real-world insight. 
              By blending AI-driven tools with vetted trading professionals, we help stabilize earnings and 
              limit emotional decision-making.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutVision;
